'use client'

import { useRect, useWindowSize } from 'hamo'
import { useRef } from 'react'
import { Button } from '~/components/button'
import { FrameSequence } from '~/components/frame-sequence'
import { Image } from '~/components/image'
import { useDeviceDetection } from '~/hooks/use-device-detection'
import { useScrollTrigger } from '~/hooks/use-scroll-trigger'
import { easeInOutQuart, easeOutExpo, easeOutQuart } from '~/libs/easings'
import { mapRange } from '~/libs/maths'
import { desktopVW } from '~/libs/utils'
import { screens } from '~/styles/layout.mjs'
import ChevronIcon from '~/svg/chevron.svg'
import MoonIcon from '~/svg/moon.svg'
import SunIcon from '~/svg/sun.svg'

const EMAILS = [
  {
    id: 1,
    title: 'Potluck: your legendary jerk-chicken?',
    from: 'Noah Chen',
    to: 'noahc.chef@gmail.com',
    body: 'We’ve got three new meeting recordings that need trimming and tagging before the pipeline run. Can you upload them to the “Pilot V2” folder and kick off processing by end of day? Marketing wants teaser clips by Friday.',
    src: '/images/emails/1.png',
    random: (Math.random() - 0.5) * 2,
    random2: (Math.random() - 0.5) * 2,
    random3: (Math.random() - 0.5) * 2,
    random4: (Math.random() - 0.5) * 2,
  },
  {
    id: 2,
    title: 'Potluck: your legendary jerk-chicken?',
    from: 'Noah Chen',
    to: 'noahc.chef@gmail.com',
    body: 'We’ve got three new meeting recordings that need trimming and tagging before the pipeline run. Can you upload them to the “Pilot V2” folder and kick off processing by end of day? Marketing wants teaser clips by Friday.',
    src: '/images/emails/2.png',
    random: (Math.random() - 0.5) * 2,
    random2: (Math.random() - 0.5) * 2,
    random3: (Math.random() - 0.5) * 2,
    random4: (Math.random() - 0.5) * 2,
  },
  {
    id: 3,
    title: 'Potluck: your legendary jerk-chicken?',
    from: 'Noah Chen',
    to: 'noahc.chef@gmail.com',
    body: 'We’ve got three new meeting recordings that need trimming and tagging before the pipeline run. Can you upload them to the “Pilot V2” folder and kick off processing by end of day? Marketing wants teaser clips by Friday.',
    src: '/images/emails/3.png',
    random: (Math.random() - 0.5) * 2,
    random2: (Math.random() - 0.5) * 2,
    random3: (Math.random() - 0.5) * 2,
    random4: (Math.random() - 0.5) * 2,
  },
  {
    id: 4,
    title: 'Potluck: your legendary jerk-chicken?',
    from: 'Noah Chen',
    to: 'noahc.chef@gmail.com',
    body: 'We’ve got three new meeting recordings that need trimming and tagging before the pipeline run. Can you upload them to the “Pilot V2” folder and kick off processing by end of day? Marketing wants teaser clips by Friday.',
    src: '/images/emails/4.png',
    random: (Math.random() - 0.5) * 2,
    random2: (Math.random() - 0.5) * 2,
    random3: (Math.random() - 0.5) * 2,
    random4: (Math.random() - 0.5) * 2,
  },
  {
    id: 5,
    title: 'Potluck: your legendary jerk-chicken?',
    from: 'Noah Chen',
    to: 'noahc.chef@gmail.com',
    body: 'We’ve got three new meeting recordings that need trimming and tagging before the pipeline run. Can you upload them to the “Pilot V2” folder and kick off processing by end of day? Marketing wants teaser clips by Friday.',
    src: '/images/emails/5.png',
    random: (Math.random() - 0.5) * 2,
    random2: (Math.random() - 0.5) * 2,
    random3: (Math.random() - 0.5) * 2,
    random4: (Math.random() - 0.5) * 2,
  },
  {
    id: 6,
    title: 'Potluck: your legendary jerk-chicken?',
    from: 'Noah Chen',
    to: 'noahc.chef@gmail.com',
    body: 'We’ve got three new meeting recordings that need trimming and tagging before the pipeline run. Can you upload them to the “Pilot V2” folder and kick off processing by end of day? Marketing wants teaser clips by Friday.',
    src: '/images/emails/6.png',
    random: (Math.random() - 0.5) * 2,
    random2: (Math.random() - 0.5) * 2,
    random3: (Math.random() - 0.5) * 2,
    random4: (Math.random() - 0.5) * 2,
  },
]

function Email({ src }) {
  return (
    <div className="email-shadow dr-rounded-12 overflow-clip">
      <Image src={src} alt={src} block className="dt:!dr-w-305 !dr-w-200" />
    </div>
  )
}

export function Recap() {
  const letterWrapperRef = useRef(null)
  const letterRef = useRef(null)

  const [setEmailsTriggerRectRef, emailsTriggerRect] = useRect()
  const [setEnveloppeRectRef, enveloppeRect] = useRect()
  const [setEnveloppeTriggerRectRef, enveloppeTriggerRect] = useRect()
  const [setLetterTriggerRectRef, letterTriggerRect] = useRect()
  const [setLetterRectRef, letterRect] = useRect()

  const backgroundSequenceRef = useRef(null)
  const foregroundSequenceRef = useRef(null)
  const sideSequenceRef = useRef(null)

  const emailsRefs = useRef([])

  const { width: windowWidth, height: windowHeight } = useWindowSize()
  const { isMobile } = useDeviceDetection()

  const layoutWidth = Math.min(
    windowWidth,
    isMobile ? screens.mobile.width : screens.desktop.width
  )

  useScrollTrigger(
    {
      rect: emailsTriggerRect,
      start: 'top bottom',
      end: 'bottom center',
      onProgress: ({ progress }) => {
        // console.log('messages', progress)

        const easeProgress = easeInOutQuart(progress)

        emailsRefs.current.forEach((node, index) => {
          const email = EMAILS[index]
          let offset = index - 3
          if (offset >= 0) {
            offset = offset + 1
          }
          const offsetSign = offset > 0 ? 1 : -1
          const localOffset = offset - offsetSign * 2

          const x =
            (1 - easeOutQuart(progress)) * (offsetSign * 60 + localOffset * 40)

          const distanceToOrigin = Math.sqrt(x * x) / 55

          const y =
            (1 - easeProgress) * -(isMobile ? 48 : 12) -
            (1 - easeProgress) * offset * 6 * offsetSign
          const rotation =
            Math.sin(easeOutQuart(distanceToOrigin) * Math.PI) *
            35 *
            -offsetSign

          const p = easeOutExpo(progress)

          node.style.transform = `translateX(${offsetSign * layoutWidth * 0.5 * (1 - p)}px) translateY(${-layoutWidth * 0.21 * (1 - p)}px) translate3d(${desktopVW(x + email.random, layoutWidth) * 12}px, ${desktopVW(y + email.random2, layoutWidth) * 12}px, 0) rotate(${rotation + email.random3 * 2}deg) `
        })
      },
    },
    [layoutWidth, windowWidth, isMobile]
  )

  useScrollTrigger({
    rect: enveloppeTriggerRect,
    start: 'top bottom',
    end: 'bottom center',
    onProgress: ({ progress }) => {
      backgroundSequenceRef.current?.setProgress(progress)
      foregroundSequenceRef.current?.setProgress(progress)

      emailsRefs.current.forEach((node, index) => {
        node.style.opacity = progress > 0.5 ? 0 : 1
      })
      letterWrapperRef.current.style.opacity = progress < 0.5 ? 0 : 1
    },
  })

  useScrollTrigger(
    {
      rect: letterTriggerRect,
      start: 'top center',
      end: 'bottom bottom',
      onProgress: ({ progress }) => {
        const padding = layoutWidth * 0.01
        const initialY = -((windowHeight - enveloppeRect.height) / 2 + padding)
        const headerHeight = desktopVW(116, layoutWidth)
        const finalY = letterRect.height - windowHeight + headerHeight
        if (progress < 0.5) {
          letterRef.current.style.transform = `translate3d(0, ${mapRange(0, 1, mapRange(0, 0.5, progress, 0, 1), initialY, finalY)}px, 0)`
        } else {
          letterRef.current.style.transform = `translate3d(0, ${mapRange(0, 1, mapRange(0.5, 1, progress, 0, 1), finalY, -padding)}px, 0)`
        }

        backgroundSequenceRef.current.getNode().style.transform = `translate3d(0, ${-mapRange(0, 0.5, progress, 0, 1) * 100}vh, 0)`
        foregroundSequenceRef.current.getNode().style.transform = `translate3d(0, ${-mapRange(0, 0.5, progress, 0, 1) * 100}vh, 0)`
        sideSequenceRef.current.style.transform = `translate3d(0, ${-mapRange(0, 0.5, progress, 0, 1) * 100}vh, 0)`

        letterWrapperRef.current.style.clipPath = `inset(calc(${(windowHeight - enveloppeRect.height) / 2 + padding}px + ${-mapRange(0, 0.5, progress, 0, 1) * 100}vh) 0 ${((window.innerHeight - enveloppeRect.height) / 2 + padding) * (progress === 0 ? 1 : 0)}px 0)`
      },
    },
    [windowHeight, layoutWidth]
  )

  return (
    <section className="">
      <div className="dt:dr-w-451 dr-w-357 mx-auto">
        <div className="flex flex-col justify-center items-center">
          <h3 className="h4-l dr-mb-8">
            The rest gets <i className="italic">Briefed</i>
          </h3>
          <p className="p-xxl dr-mb-25  text-center">
            Twice a day, Cora sends you a beautiful Brief that summarizes
            everything you need to read but don’t need to respond to. It lets
            you read your inbox in 30 seconds instead of 3 hours.
          </p>
          <Button
            href="https://cora.computer/users/sign_up"
            label="Get started"
          />
        </div>
      </div>
      <div className="relative overflow-x-clip">
        <div ref={setEmailsTriggerRectRef} className={`dr-h-1080 opacity-50`} />
        <div
          ref={setEnveloppeTriggerRectRef}
          className={`dr-h-1080 opacity-50`}
        />
        <div ref={setLetterTriggerRectRef} className={`dr-h-1440 opacity-50`} />
        <div className="absolute top-0 left-0 right-0 h-full">
          <div className="sticky top-0 h-[100svh]">
            <div className="absolute inset-0 flex items-center justify-center">
              <FrameSequence
                ref={backgroundSequenceRef}
                // className={s.sequence}
                frames={Array.from({
                  length: 38,
                }).map((_, index) => `/images/background/${index + 1}.webp`)}
                className="aspect-[2918/4346] dt:dr-w-549 dr-w-357"
              />
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              {EMAILS.map((email, index) => (
                <div
                  key={email.id}
                  className="absolute"
                  ref={(node) => {
                    emailsRefs.current[index] = node
                  }}
                >
                  <Email {...email} />
                </div>
              ))}
            </div>
            <div
              ref={letterWrapperRef}
              className="absolute  inset-0 flex items-end justify-center"
            >
              <div
                className="dt:dr-w-504 dr-w-329 flex flex-col dt:dr-gap-13"
                ref={(node) => {
                  letterRef.current = node
                  setLetterRectRef(node)
                }}
              >
                <h3 className="dt:dr-mb-22 dr-mb-44 text-center h4-l">
                  Today’s Brief
                </h3>
                <div className="flex justify-between font-switzer dr-text-12 dr-h-28 desktop-only">
                  <div className="dr-p-3 flex dr-gap-7 bg-[#065BA3] dr-rounded-24">
                    <div className="flex dr-gap-4 items-center dr-px-12">
                      <SunIcon className="dr-w-14 aspect-square" />
                      <span>Morning</span>
                    </div>
                    <div className="flex dr-gap-5 items-center bg-[#488FCB] dr-rounded-24 dr-px-20 dr-py-2 ">
                      <MoonIcon className="dr-w-14 aspect-square" />
                      <span>Afternoon</span>
                    </div>
                  </div>
                  <div className="dr-px-17 dr-py-8 bg-[#FFFFFF05] backdrop-blur-[9px] dr-rounded-17 dr-border-1 dr-border-[#FFFFFF] border-solid flex dr-gap-7 items-center">
                    <span className="whitespace-nowrap">All accounts</span>
                    <ChevronIcon className="dr-w-9 dr-h-6" />
                  </div>
                </div>
                <div className="aspect-[791/1174] relative">
                  <Image
                    src="/images/brief.png"
                    alt=""
                    desktopSize="32vw"
                    mobileSize="100vw"
                    fill
                  />
                </div>
              </div>
            </div>
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="aspect-[2918/4346] dt:dr-w-549 dr-w-357 relative">
                <Image
                  src="/images/sides.webp"
                  alt=""
                  unoptimized
                  fill
                  ref={sideSequenceRef}
                />
                <FrameSequence
                  ref={foregroundSequenceRef}
                  // className={s.sequence}
                  frames={Array.from({
                    length: 38,
                  }).map((_, index) => `/images/foreground/${index + 1}.webp`)}
                  className="absolute inset-0 w-full h-full"
                />
                <div
                  ref={setEnveloppeRectRef}
                  className="absolute top-[50%] translate-y-[-50%] w-full aspect-[423/282]"
                />
              </div>
            </div>
          </div>
        </div>
        {/* <div className="h-[1000vh] absolute top-0 left-0 right-0"> */}
        {/* <div className="h-[100vh] flex items-end justify-center"> */}
        {/* <div className="flex items-end justify-center aspect-[422/280] bg-[red] dr-w-549 opacity-50"> */}

        {/* </div> */}
      </div>
      {/* </div> */}
      {/* </div> */}
    </section>
  )
}
